var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.layout,{tag:"component"},[_c('router-view',{attrs:{"layout":_vm.layout,"role":"main"},on:{"update:layout":function($event){_vm.layout=$event}}}),_c('vue-progress-bar')],1),_c('portal-target',{attrs:{"name":"body"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }